<template>
  <div>
    <el-card>
      <el-table
        v-loading="loading"
        :data="items"
        size="small"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="Date"
          :formatter="formatter"
          prop="created_at"
        />
        <el-table-column align="center" label="Amount" prop="amount">
          <template #default="{ row }">
            {{ row.attributes.currency_sign }}{{ row.attributes.amount }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="Invoice">
          <template #default="{ row }">
            <el-link
              v-if="row.attributes.message"
              type="primary"
              target="_blank"
              :href="row.attributes.message"
            >
              Download invoice
              <el-icon class="el-icon--right">
                <DownloadElementIcon />
              </el-icon>
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <Pagination
      v-if="total > 0"
      :total="total"
      :page="page"
      @pagination="applyPagination"
    />
  </div>
</template>
<script lang="ts">
import { computed, ref, defineComponent } from 'vue'
import Pagination from '@/components/Pagination.vue'

export default defineComponent({
  name: 'InvoicesTable',
  components: {
    Pagination
  },
  props: {
    total: {
      type: Number,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const loading = ref(false)
    const page = ref(1)
    const formatter = (row: any, col: any) => {
      const prop = String(col.property)
      return row.attributes[prop]
    }

    const applyPagination = (options: any) => {
      page.value = options.page
      context.emit('update', options)
    }
    return {
      applyPagination,
      formatter,
      loading,
      page
    }
  }
})
</script>

<style lang="scss" scoped></style>
